import React from 'react'

import AvailabilityStore from '../stores/AvailabilityStore.js'
import AvailabilityActions from '../actions/AvailabilityActions.js'

import { translate } from 'react-i18next';

var AddressNotFound = React.createClass({

  getInitialState() {
    return {store: AvailabilityStore.getState()};
  },

  componentDidMount() {
    AvailabilityStore.listen(this.onChange);
  },

  componentWillUnmount() {
    AvailabilityStore.unlisten(this.onChange);
  },

  onChange(state) {
    this.setState({store: state});
  },

  updateContactInfo(event) {
    if(event.type == 'click') {
      return;
    }
    AvailabilityActions.updateContactInfo(event.target.name, event.target.value);
  },

  submitContactMe(event) {
  	AvailabilityActions.submitResContactMe(this.state.store.toJS());
      event.preventDefault();
      event.stopPropagation();
      return false;
  },

  render() {
      const { t } = this.props;
    var store = this.state.store;
    var prequal_key;

    if(store.get('sso_user')) {
      prequal_key = <div>Prequal Key: {store.get('async_id')}</div>
    }
  	return (
  		<div>
  		  <h2>{t('common:address_not_found_header')}</h2>
        <p className="lead">{t('common:please_try_again')}</p>
        <p className="lead">{t('common:you_entered')} <span className="text-nowrap"> {store.getIn(['input_address', 'streetAddress'])} {store.getIn(['input_address', 'secondary'])}, {store.getIn(['input_address', 'zip'])}</span></p>
        {prequal_key}
        <a href="" className="btn btn-lg btn-primary">{t('common:try_again_button')}</a>

        <div className="tips">
          <h3>{t('common:helpful_tips_header')}</h3>
          <ul>
            <li>{t('common:tip_include_all')}</li>
            <li>{t('common:tip_directional')}</li>
            <li>{t('common:tip_numbered_st')}</li>
            <li>{t('common:tip_abbrev')}</li>
          </ul>
        </div>
      </div>
  	)
  }
});

export default  translate('common', { wait: true })(AddressNotFound);